import { Button } from '#/components/Button/Button';
import { RichTextHeadline } from '#/components/Text/RichTextHeadline';
import type { CmsApiFourArticlesHighlightBlockData } from '#/modules/cms/api/types/blocks/CmsApiFourArticlesHighlightBlock';
import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';
import { isNotEmpty } from '#/utils/functional/poly';

import {
  CmsFourArticlesHighlightBlock_Box_1,
  CmsFourArticlesHighlightBlock_Box_2,
  CmsFourArticlesHighlightBlock_Box_3,
} from './CmsFourArticlesHighlightBlock.styled';
import { CmsFourArticlesHighlightBlockPageSection } from './CmsFourArticlesHighlightBlockPageSection';

type Props = {
  content: CmsApiDocument;
  data: CmsApiFourArticlesHighlightBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsFourArticlesHighlightBlock({
  content,
  data,
  blockIndex,
  pageUpdated,
}: Props) {
  const { subsite } = content;

  const ARTICLES = [
    data.pageOne,
    data.pageTwo,
    data.pageThree,
    data.pageFour,
  ].filter(Boolean);

  const { headline, buttonText, buttonUrl } = data;

  const displayImages =
    ARTICLES.some((page) => page.image) ||
    isNotEmpty(subsite?.placeholderImages);

  return (
    <div
      data-qa-id="cms-four-article-highlight"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        width: '100%',
      }}
    >
      {headline && (
        <CmsFourArticlesHighlightBlock_Box_3>
          <RichTextHeadline>{headline}</RichTextHeadline>
        </CmsFourArticlesHighlightBlock_Box_3>
      )}

      <CmsFourArticlesHighlightBlock_Box_2>
        {ARTICLES.map((page, index) => (
          <CmsFourArticlesHighlightBlockPageSection
            qaId={`four-article-highlight-section-${index}`}
            page={page}
            key={page.id}
            displayImages={displayImages}
            blockIndex={blockIndex}
            pageUpdated={pageUpdated}
            subsite={subsite}
            isInPost={content.type === 'POST'}
          />
        ))}
      </CmsFourArticlesHighlightBlock_Box_2>

      {buttonText && buttonUrl && (
        <CmsFourArticlesHighlightBlock_Box_1>
          <Button type="link" href={buttonUrl} variant="primary">
            {buttonText}
          </Button>
        </CmsFourArticlesHighlightBlock_Box_1>
      )}
    </div>
  );
}
